/*  every "How to choose an ITA bag" link (a[href*="/pages/ita-bag-guide"]) opens the Compare all sheet in guide mode
   (full table, a photo on every column, quick picks) instead of leaving the page. Loaded once from layout/theme.liquid.
   - Pages that already have the sheet (homepage bag finder): opens it straight away.
   - Anywhere else: fetches sections/pb-guide-compare via the Section Rendering API on the first hover, focus or tap, adds its
     styles and markup to the page, runs assets/pb-compare-all.js, then opens it.
   - Cmd / ctrl / shift / alt / middle clicks and target=_blank still open the page, and if loading fails the link navigates,
     so /pages/ita-bag-guide stays a normal, indexable page SEO). Scroll lock, focus trap and focus return live in
     assets/pb-compare-all.js (released on every close path). [data-pb-compare-all] buttons (product page "Compare all ITA bags") open the same sheet in plain compare mode;
     if it cannot load they go to their data-href (the ITA bags collection). */
(function(){
  'use strict';
  if (window.PBGuidePop) return;
  var SEL = 'a[href*="/pages/ita-bag-guide"]';
  var CMP = '[data-pb-compare-all]';
  var loading = null;

  function ready(){ return !!(window.PBCompareAll && window.PBCompareAll._ready); }
  function base(){ var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root; return r || '/'; }
  function guideLink(t){
    var a = t && t.closest ? t.closest(SEL) : null;
    if (!a || a.hasAttribute('data-guide-page') || (a.target && a.target !== '_self') || a.hasAttribute('download')) return null;
    /* a quiz trigger that keeps the guide page as its no-script fallback (Take the full quiz) opens only the quiz */
    if (a.closest('[data-pbq-open]')) return null;
    try { if (new URL(a.href, location.href).hostname !== location.hostname) return null; } catch (e) { return null; }
    return a;
  }

  function load(){
    if (ready()) return Promise.resolve();
    if (loading) return loading;
    loading = fetch(base() + '?section_id=pb-guide-compare', { credentials: 'same-origin' })
      .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function(html){
        if (ready()) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[data-pbca]'), js = doc.querySelector('script[src*="pb-compare-all"]');
        if (!node || !js) throw new Error('no comparison table');
        /* styles go at the END of <body>, as on the homepage: the theme's own button rules (theme.css, inline [type=button]) tie on
           specificity, so the comparison's rules must come later in the document to win */
        [].forEach.call(doc.querySelectorAll('style'), function(st){ document.body.appendChild(document.importNode(st, true)); });
        document.body.appendChild(document.importNode(node, true));
        return new Promise(function(res, rej){
          var s = document.createElement('script');
          s.src = js.getAttribute('src');
          s.onload = function(){ ready() ? res() : rej(new Error('comparison did not start')); };
          s.onerror = function(){ rej(new Error('script failed')); };
          document.head.appendChild(s);
        });
      });
    loading.catch(function(){ loading = null; });
    return loading;
  }

  function cmpBtn(t){ return t && t.closest ? t.closest(CMP) : null; }

  function open(a, compare){
    if (window.pbQuickView && window.pbQuickView.isOpen && window.pbQuickView.isOpen()) { try { window.pbQuickView.close(); } catch (e) {} }
    if (a) a.setAttribute('aria-busy', 'true');
    load().then(function(){
      if (a) a.removeAttribute('aria-busy');
      window.PBCompareAll.open({ guide: !compare, opener: a || document.activeElement });
    }).catch(function(err){
      if (a) a.removeAttribute('aria-busy');
      if (window.console) console.warn('[pb-guide-pop] opening the guide page instead:', err && err.message);
      location.href = compare ? ((a && a.getAttribute('data-href')) || base() + 'collections/ita-bags') : (a ? a.href : base() + 'pages/ita-bag-guide');
    });
  }

  /* capture phase: runs before the page-transition handler (snippets/pb-motion), which skips prevented clicks */
  document.addEventListener('click', function(e){
    if (e.defaultPrevented || e.button !== 0) return;
    var c = cmpBtn(e.target);
    if (c){ e.preventDefault(); if (c.getAttribute('aria-busy') !== 'true') open(c, true); return; }
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = guideLink(e.target); if (!a) return;
    e.preventDefault();
    open(a);
  }, true);
  /* warm it up on intent so the tap opens without a wait */
  function warm(e){ if (!loading && !ready() && (guideLink(e.target) || cmpBtn(e.target))) load().catch(function(){}); }
  document.addEventListener('pointerover', warm, { passive: true });
  /* pages with a Compare all ITA bags button fetch the sheet once the page is idle, so the first tap opens it at once */
  function pre(){ if (!document.querySelector(CMP) || loading || ready()) return; (window.requestIdleCallback || function(f){ setTimeout(f, 1200); })(function(){ load().catch(function(){}); }, { timeout: 4000 }); }
  if (document.readyState === 'complete') pre(); else window.addEventListener('load', pre, { once: true });
  document.addEventListener('touchstart', warm, { passive: true });
  document.addEventListener('focusin', warm);

  window.PBGuidePop = { open: function(a){ open(a || null); }, compare: function(a){ open(a || null, true); }, load: load };
})();
